import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { watchUpdateUser } from './saga';
import { UserState, userdata } from './types';

export const initialState: UserState = {
  loading: true,
  success: false,
  error: null,
};

export const Userslice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    updateUser(state, action: PayloadAction<userdata>) {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    updateUserSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    updateUserFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    updateUserReset(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
});

export const { actions: updateUseractions } = Userslice;
export const useUserslice = () => {
  useInjectReducer({ key: Userslice.name, reducer: Userslice.reducer });
  useInjectSaga({ key: Userslice.name, saga: watchUpdateUser });
  return { actions: Userslice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
